import { Blocks } from "lucide-react";
import React from "react";
import { FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn, FaYoutube } from "react-icons/fa";


export default function FooterCard3() {
  return (<>
    <footer className="footer-fc-3-wrapper">

      {/* Newsletter Section */}
      <div className="newsletter-bar">
        <div className="newsletter-left">
          <div className="newsletter-circle" ><Blocks size={35} /></div>
          <h3>NEWSLETTER SIGN UP</h3>
          <p>
              Vivamus finibus pretium libero eget fermentum.
          </p>
        </div>

        <div className="newsletter-right">
          <input type="email" placeholder="Your Email" />
          <button>SUBSCRIBE</button>
        </div>
      </div>

      {/* Footer Content */}
      <div className="footer-fc-3-content">

        {/* About Charity */}
        <div className="footer-fc-3-col">
          <h4>ABOUT Vision Classes</h4>
        
          <p>
            Phasellus in est urna. Class aptent taciti sociosqu ad litora torquent per conubia nostra.
          </p>
        </div>

        {/* Twitter Feed */}
        <div className="footer-fc-3-col">
          <h4>Contact</h4>
          <p>For payment or technical issues:</p>
          <p >support@example.com</p>
        </div>

        {/* Leave message */}
        <div className="footer-fc-3-col">
          <h4>Privacy Policy</h4>
        <p> <a href="#">Privacy Policy</a></p> 
         <p> <a href="#">Terms of Service</a></p>  
       
            <button className="submit-btn-fc-3">Contact Us</button>
        </div>

        {/* Recent Posts */}
        <div className="footer-fc-3-col">
          <h4>Recent Posts</h4>
          <div className="recent-item">
            <span className="recent-img-fc-3" > <FaFacebookF />  </span>
           <span className="recent-img-fc-3" > <FaInstagram />
                        </span>
           <span className="recent-img-fc-3" >  <FaLinkedinIn />
                        </span>
           <span className="recent-img-fc-3" > <FaYoutube />  </span>
            
          </div>
         

          <button className="buy-btn-fc-3">Explore Courses</button>
        </div>

      </div>

      {/* Bottom Line */}
      <div className="footer-fc-3-bottom">
        © 2025 Charity Foundation. All Rights Reserved.
      </div>
    </footer>
    <style>{`.footer-fc-3-wrapper {
  background: #111;margin-top:50px;
  color: #fff;
  font-family: "Inter", sans-serif;
}

/* Newsletter Bar */
.newsletter-bar {
  background: rgba(144, 202, 249,1);
  padding: 10px 8%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}

.newsletter-left {
  max-width: 400px;
}

.newsletter-left h3 {
  font-size: 18px;
  font-weight: 800;
  letter-spacing: 1px;
}

.newsletter-left p {
  color: #333333;
  font-size: 14px;
}

.newsletter-circle {
  width: 70px;display:flex;justify-content:center;align-items:center;
  height: 70px;
  border-radius: 50%;
  background: rgba(255,255,255,0.3);
  margin-bottom: 10px;
}

.newsletter-right {
  display: flex;
  flex-direction: column;
  max-width: 450px;
  width: 100%;
}

.newsletter-right input {
  padding: 14px;
  border: none;
  outline: none;
  margin-bottom: 10px;
  border-radius: 3px;
}

.newsletter-right button {
  background: #222;
  color: #fff;
  border: none;
  padding: 12px;
  font-weight: 700;
  cursor: pointer;
  border-radius: 3px;
}

/* Footer Grid */
.footer-fc-3-content {
  padding: 50px 8%;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(230px, 1fr));
  gap: 40px;
}

.footer-fc-3-col h4 {
  margin-bottom: 12px;padding-left:10px;
  border-left: 2px solid rgba(144, 202, 249,1);
  display: inline-block;
  padding-bottom: 4px;
}

.footer-fc-3-col a {
 
  color: rgba(144, 202, 249,0.51);
}

.footer-fc-3-col p {
 
  color: rgba(252, 240, 240, 0.51);
}

.submit-btn-fc-3 {
  background: rgba(144, 202, 249,1);
  color: #fff;
  border: none;
  padding: 10px 18px;
  cursor: pointer;
  border-radius: 3px;
}

.recent-item {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}

.recent-img-fc-3 {
  width: 45px;display:flex;justify-content:center;align-items:center;
  height: 45px;
  background: #555555;color:#111111;
  border-radius: 4px;
  margin-right: 10px;
}

.buy-btn-fc-3 {
  margin-top: 10px;width:100%;
  background: rgba(144, 202, 249,1);
  padding: 10px 18px;
  border: none;
  color: #fff;
  cursor: pointer;
  border-radius: 3px;
}

.footer-fc-3-bottom {
  text-align: center;
  color: #bbb;
  padding: 20px;
  border-top: 1px solid #222;
  font-size: 14px;
}
`}</style>
    </>
  );
}
